import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { SiteApp } from "./SiteApp";
import { ApiFrameworkProvider } from "./framework";
import { groundworksPublicMountMetaName, resolveGroundworksMountPath } from "./routerMount";
import "./styles.css";

const root = document.getElementById("root");
if (!root) throw new Error("Application root is missing");
const publicMountPath = document
  .querySelector<HTMLMetaElement>(`meta[name="${groundworksPublicMountMetaName}"]`)
  ?.getAttribute("content");
const apiBaseUrl = resolveGroundworksMountPath(publicMountPath) ?? "";

createRoot(root).render(
  <StrictMode>
    <SiteApp provider={new ApiFrameworkProvider(apiBaseUrl)} />
  </StrictMode>
);
